import BuscarReservacion from './BuscarReservacion.js';

const ConsultarReservacion = () => {
  return (
    <div>
      <BuscarReservacion  rutaDestino="reservacion" />
    </div>
  );
};

export default ConsultarReservacion;
